import Api from "@/helpers/fetch"
import { isArray } from "lodash"

export default class SacramentApis {
    /**
     * Add sacrament attendance record
     * @param {Object} params - date_attendance, ward, number_of_attendees, total_number_of_attendees
     * @param {Function} callback
     */
    static async addAttendanceRecord({params, callback} = {}) {
        const url = `stakeapi/v1/sacrament_attendance/create_attendance`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback?.(res)
    }

    /**
     * Get sacrament attendance records
     * @param {Function} callback 
     * 
     */
    static async getAttendanceRecords({callback} = {}) {
        const url = `stakeapi/v1/sacrament_attendance/all`
        const res = await Api.fetch({
            url,
            method : "GET"
        })

        console.log('getAttenace is array', isArray(res))

        if(res && isArray(res)) callback?.(res)
    }

    /**
     * Update sacrament attendance record
     * @param {Object} params - id, date_attendance, ward, number_of_attendees, total_number_of_attendees
     * @param {Function} callback
     */
    static async updateAttendanceRecord({params, callback} = {}) {
        const url = `stakeapi/v1/sacrament_attendance/update_ward_attendance`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback?.(res)
    }

    /**
     * Delete sacrament attendance record
     * @param {Object} params - date_attendance, ward
     * @param {Function} callback
     */
    static async deleteAttendanceRecord({params, callback} = {}) {
        const url = `stakeapi/v1/sacrament_attendance/remove_attendance`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback?.(res)
    }

}